import CustomerRecord            from "../../../../domain/record/customer/CustomerRecord";
import CustomerRecordTemplate    from "../../../../domain/record/customer/CustomerRecordTemplate";
import CustomerRecordWidget      from "../../../../domain/record/customer/widget/CustomerRecordWidget";
import CustomerRecordWidgetItem  from "../../../../domain/record/customer/widget/item/CustomerRecordWidgetItem";
import CustomerRecordWidgetItems from "../../../../domain/record/customer/widget/item/CustomerRecordWidgetItems";
import WidgetItemValue           from "../../../../domain/record/widget/item/WidgetItemValue";
import WidgetType                from "../../../../domain/record/widget/WidgetType";
import {
  ACTION_TYPE,
  CustomerRecordAction,
  SetCustomerRecordAction,
  SetCustomerRecordDateAction,
  SetCustomerRecordWidgetAction,
  SetCustomerRecordWidgetItemAction
}                                from "./CustomerRecordAction";

const reduceCustomerRecord = (action: SetCustomerRecordAction): CustomerRecord => action.customerRecord;
const reduceCustomerRecordDate = (state: CustomerRecord, action: SetCustomerRecordDateAction): CustomerRecord => {
  return new CustomerRecord(
    state.id,
    action.date,
    state.template,
  );
};
const reduceWidget = (state: CustomerRecord, action: SetCustomerRecordWidgetAction): CustomerRecord => {
  return new CustomerRecord(
    state.id,
    state.date,
    new CustomerRecordTemplate(
      state.template.id,
      state.template.revision,
      state.template.name,
      state.template.widgets.replace(action.widgetIndex, action.widget)
    )
  );
};

const reduceWidgetItem = (state: CustomerRecord, action: SetCustomerRecordWidgetItemAction): CustomerRecord => {
  const widget: CustomerRecordWidget = state.template.widgets.findByIndex(action.widgetIndex);
  switch (widget.type.value) {
    default:
      return new CustomerRecord();
    case WidgetType.RADIO_VERTICAL:
    case WidgetType.RADIO_HORIZONTAL:
      return reduceWidgetRadioItem(state, action);
    case WidgetType.CHECK_VERTICAL:
    case WidgetType.CHECK_HORIZONTAL:
      return reduceWidgetCheckItem(state, action);
  }
};

const reduceWidgetRadioItem = (state: CustomerRecord, action: SetCustomerRecordWidgetItemAction): CustomerRecord => {
  const widget: CustomerRecordWidget = state.template.widgets.findByIndex(action.widgetIndex);
  const widgetItems: CustomerRecordWidgetItems = new CustomerRecordWidgetItems(
    widget.items.toList().map((widgetItem, widgetItemIndex) => (
      new CustomerRecordWidgetItem(widgetItem.id, widgetItem.widgetItemId, widgetItem.title, widgetItemIndex === action.widgetItemIndex ? action.widgetItem.value : new WidgetItemValue())
    ))
  );

  return new CustomerRecord(
    state.id,
    state.date,
    new CustomerRecordTemplate(
      state.template.id,
      state.template.revision,
      state.template.name,
      state.template.widgets.replace(action.widgetIndex, new CustomerRecordWidget(widget.id, widget.widgetId, widget.type, widget.coordinate, widget.title, widget.value, widgetItems))
    )
  );
};

const reduceWidgetCheckItem = (state: CustomerRecord, action: SetCustomerRecordWidgetItemAction): CustomerRecord => {
  const widget: CustomerRecordWidget = state.template.widgets.findByIndex(action.widgetIndex);
  const widgetItems: CustomerRecordWidgetItems = new CustomerRecordWidgetItems(
    widget.items.toList().map((widgetItem, widgetItemIndex) => (
      new CustomerRecordWidgetItem(widgetItem.id, widgetItem.widgetItemId, widgetItem.title, widgetItemIndex === action.widgetItemIndex ? widgetItem.value.value === "select" ? new WidgetItemValue() : action.widgetItem.value : widgetItem.value)
    ))
  );

  return new CustomerRecord(
    state.id,
    state.date,
    new CustomerRecordTemplate(
      state.template.id,
      state.template.revision,
      state.template.name,
      state.template.widgets.replace(action.widgetIndex, new CustomerRecordWidget(widget.id, widget.widgetId, widget.type, widget.coordinate, widget.title, widget.value, widgetItems))
    )
  );
};

const customerRecordReducer = (state: CustomerRecord = new CustomerRecord(), action: CustomerRecordAction): CustomerRecord => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_CUSTOMER_RECORD:
      return reduceCustomerRecord(action as SetCustomerRecordAction);
    case ACTION_TYPE.SET_CUSTOMER_RECORD_DATE:
      return reduceCustomerRecordDate(state, action as SetCustomerRecordDateAction);
    case ACTION_TYPE.SET_CUSTOMER_RECORD_WIDGET_VALUE:
      return reduceWidget(state, action as SetCustomerRecordWidgetAction);
    case ACTION_TYPE.SET_CUSTOMER_RECORD_WIDGET_ITEM_VALUE:
      return reduceWidgetItem(state, action as SetCustomerRecordWidgetItemAction);
  }
};

export default customerRecordReducer;
